import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import useWhatsNew from '../hooks/useWhatsNew';
import './WhatsNewBell.css';

/** Значок «Новое» в шапке: число непрочитанных важных и новых обновлений, нажатие ведёт на «Что нового». */
export default function WhatsNewBell({ variant = 'sidebar' }) {
  const navigate = useNavigate();
  const { count } = useWhatsNew();
  return (
    <button type="button" className={`wn-bell wn-bell--${variant}`} onClick={() => navigate('/whats-new')}
            title={count ? `Новое: непрочитанных ${count}` : 'Что нового'} aria-label={count ? `Что нового: непрочитанных ${count}` : 'Что нового'}>
      <Sparkles size={17} />
      {count > 0 && <span className="wn-bell__count">{count > 9 ? '9+' : count}</span>}
    </button>
  );
}
